<template>
  <form class="form" method="put">

    <div id="appTarifEditVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Modifier mon tarif</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Nom*</p>
          </div>
          <div class="appGroupOfInput">
            <select v-model="tarif.category" type="string" name="category" class="appInputStyle1">
              <option valeur="Femmes">Femmes</option>
              <option valeur="Femmes">Suppléments</option>
              <option valeur="Femmes">Cérémonie</option>
              <option valeur="Hommes">Hommes</option>
              <option valeur="Enfants">Enfants</option>
              <option valeur="Enfants">Soins</option>
            </select>
            <input v-model="tarif.name" type="string" name="name" class="appInputStyle1"
              placeholder="Nom de la prestation">
          </div>
        </div>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle1">Prix</p>
            <p class="appLabelStyle1">S</p>
            <p class="appLabelStyle1">M</p>
            <p class="appLabelStyle1">L</p>
            <p class="appLabelStyle1">XL</p>
          </div>
          <div class="appGroupOfInput2">
            <input v-model="tarif.priceUnique" type="number" step=".01" name="priceUnique" class="appInputStyle1">
            <input v-model="tarif.priceS" type="number" step=".01" name="priceS" class="appInputStyle1">
            <input v-model="tarif.priceM" type="number" step=".01" name="priceM" class="appInputStyle1">
            <input v-model="tarif.priceL" type="number" step=".01" name="priceL" class="appInputStyle1">
            <input v-model="tarif.priceXL" type="number" step=".01" name="priceXL" class="appInputStyle1">
          </div>
        </div>
      </div>
      <br>
      <button @click.prevent="modifyTarif()" type="submit" class="appButtonModel2">Modifier mon tarif</button>
      <button @click.prevent="deleteTarif()" type="submit" class="appButtonModel2">Supprimer mon tarif</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'TarifEdit',
  data () {
    return {
      category: '',
      name: '',
      priceUnique: '',
      priceS: '',
      priceM: '',
      priceL: '',
      priceXL: '',
      errorMsg: '',
      tarif: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/tarifs/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.tarif = response.data
      })
  },
  methods: {
    modifyTarif () {
      // Test si champs remplis
      if (this.category !== null || this.name !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage + ID Tarif
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        const url = document.location.href
        const idToModify = url.substring(url.lastIndexOf('=') + 1)
        axios
          .put('https://privilegia.fr/api/tarifs/' + idToModify,
            {
              'userId': decryptedToken.userId,
              'category': this.tarif.category.toUpperCase(),
              'name': this.tarif.name,
              'priceUnique': this.tarif.priceUnique,
              'priceS': this.tarif.priceS,
              'priceM': this.tarif.priceM,
              'priceL': this.tarif.priceL,
              'priceXL': this.tarif.priceXL
            }, { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Données du tarif modifiées')
            this.$router.push('/App/Tarifs')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner la catégorie et le nom'
            console.log(error.response.data)
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner la catégorie et le nom'
      }
    },
    deleteTarif () {
      if (window.confirm('Supprimer ce tarif ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const url = document.location.href
        const idToDelete = url.substring(url.lastIndexOf('=') + 1)
        axios
          .delete('https://privilegia.fr/api/tarifs/' + idToDelete,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Tarif supprimé')
            this.$router.push('/App/Tarifs')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppTarifsEdit.vue